export const SET_PROFILE_PICTURE_EDITOR = "SET_PROFILE_PICTURE_EDITOR";
export const SET_PROFILE_PICTURE = "SET_PROFILE_PICTURE";
export const SET_PROFILE_PICTURE_SCALE = "SET_PROFILE_PICTURE_SCALE";
export const SET_PROFILE_PICTURE_DEGREE = "SET_PROFILE_PICTURE_DEGREE";
export const TOGGLE_CV_UPLOAD_SUCCESS_POP_UP = "TOGGLE_CV_UPLOAD_SUCCESS_POP_UP";
export const TOGGLE_INITIAL_SETUP_COMPLETED = "TOGGLE_INITIAL_SETUP_COMPLETED";
export const TOGGLE_EMAIL_VERIFIED_ALERT = "TOGGLE_EMAIL_VERIFIED_ALERT";
export const TOGGLE_RESEND_EMAIL = "TOGGLE_RESEND_EMAIL";